







































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class UiTimePicker extends BaseComponent {
  @Prop()
  value: string;

  @Prop()
  min: any;

  @Prop()
  max: any;

  @Prop({ default: 5 })
  step: any;

  @Prop()
  rules: any;

  @Prop()
  disabled: any;
  
  @Prop()
  readonly: any;

  time: string;
  menuTimePicker = false;

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.time = v && v.length > 5 ? v.substring(0, 5) : v;
  }

  onTimeChange(time) {
    this.$emit('input', time);
    this.$emit('change', time);
  }

  isAllowedMinutes(m) {
    if (!this.step) {
      return true;
    }
    return m % this.step === 0;
  }
}
